import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ISidebarMenuProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useSidebarRootContext
} from "../../context";
import SidebarMenuSubButton from "../menuSubButton";
import SidebarMenuSubItem from "../menuSubItem";
import SidebarMenuButton from "../menuButton";
import SidebarMenuBadge from "../menuBadge";
import SidebarMenuItem from "../menuItem";
import SidebarMenuSub from "../menuSub";

const SidebarMenu: FC<ISidebarMenuProps> = ({
    customTheme: customThemeProp,
    size = "medium",
    children,
    items,
    style,
    ...props
}) => {
    const root = useSidebarRootContext({
        part: "Sidebar.Menu"
    });

    const customTheme = customThemeProp ?? root?.customTheme;

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    const renderItems = () => {
        if(!items) {
            return null;
        }

        return items.map((item) => {
            const hasSub = !!item.items?.length;

            return <SidebarMenuItem
                key={item.key}
            >
                <SidebarMenuButton
                    isDisabled={item.isDisabled}
                    customTheme={customTheme}
                    isActive={item.isActive}
                    onPress={item.onPress}
                    title={item.title}
                    href={item.href}
                    icon={item.icon}
                    size={size}
                />
                {
                    item.count !== undefined && <SidebarMenuBadge
                        customTheme={customTheme}
                        type={item.countType}
                        count={item.count}
                    />
                }
                {
                    hasSub && <SidebarMenuSub
                        customTheme={customTheme}
                    >
                        {
                            item.items?.map((subItem) => <SidebarMenuSubItem
                                key={subItem.key}
                            >
                                <SidebarMenuSubButton
                                    isDisabled={subItem.isDisabled}
                                    isActive={subItem.isActive}
                                    customTheme={customTheme}
                                    onPress={subItem.onPress}
                                    title={subItem.title}
                                    href={subItem.href}
                                />
                                {
                                    subItem.count !== undefined && <SidebarMenuBadge
                                        customTheme={customTheme}
                                        type={subItem.countType}
                                        count={subItem.count}
                                    />
                                }
                            </SidebarMenuSubItem>)
                        }
                    </SidebarMenuSub>
                }
            </SidebarMenuItem>;
        });
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        role="list"
    >
        {renderItems()}
        {children}
    </View>;
};
export default SidebarMenu;
